import { Button, Col, Form, Input, Row, Space } from 'antd';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { IFormProps } from '../../../typings';
import { FORGOT_PASSWORD_ROUTE, REGISTER_ROUTE } from '../../routes';

export function LoginFrom({ loading, ...rest }: IFormProps) {
  const { t } = useTranslation();

  return (
    <Form layout="vertical" {...rest}>
      <Form.Item
        label={t('EMAIL_LABEL')}
        name="email"
        labelCol={{ span: 24 }}
        rules={[
          {
            required: true,
            type: 'email',
          },
        ]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        label={t('PASSWORD_LABEL')}
        name="password"
        labelCol={{ span: 24 }}
        rules={[
          {
            required: true,
          },
        ]}
        hasFeedback
      >
        <Input.Password />
      </Form.Item>
      <Form.Item className="text-center">
        <Space style={{ width: '100%' }} direction="vertical">
          <Row justify="end">
            <Col>
              <Link to={FORGOT_PASSWORD_ROUTE}>{t('FORGOT_PASSWORD_LINK')}</Link>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Button type="primary" loading={loading} htmlType="submit" block>
                {t('LOGIN_BUTTON')}
              </Button>
            </Col>
            <Col span={24} style={{ textAlign: 'center', padding: '10px 0' }}>
              <strong>{t('LOGIN_FORM_TEXT')}</strong>
            </Col>
            <Col span={24}>
              <Link to={REGISTER_ROUTE}>
                <Button style={{ width: '100%' }} type="primary">
                  {t('CREATE_ACCOUNT_BUTTON')}
                </Button>
              </Link>
            </Col>
          </Row>
        </Space>
      </Form.Item>
    </Form>
  );
}
